import type { CentrifugeMessage } from '../messageTypes';

export interface MissionMessageUnparsed {
  data: {
    type: 'Mission';
    message: string;
    created_at?: number;
  };
  offset: number;
}

export const isMissionMessageUnparsed = (item: CentrifugeMessage): item is MissionMessageUnparsed => {
  return 'data' in item && item.data.type === 'Mission' && typeof item.data.message === 'string';
};

export type MissionMessageType =
  | 'on'
  | 'off'
  | 'add'
  | 'spon'
  | 'accept'
  | 'cancel'
  | 'fail'
  | 'success'
  | 'hide'
  | 'unhide';

export interface MissionMessage {
  data: {
    type: 'Mission';
    message: {
      data?: {
        missionIdx: string | number;
        coin: string | number;
        title: string;
        userId: string;
        userIdx: string | number;
        nick: string;
        lev: number;
        rk: number;
        image: string;
        json: string;
        type?: 'on' | 'off';
      };
      type: MissionMessageType;
    };

    created_at?: number;
  };
  offset: number;
}

export const isMissionMessage = (item: CentrifugeMessage): item is MissionMessage => {
  return (
    'data' in item && item.data.type === 'Mission' && typeof item.data.message !== 'string' && !!item.data.message.type
  );
};
